import dayjs from 'dayjs'

import { businessTimeZone, formatBusinessDate, userTimeZone } from '../../utils/date'

export const MAX_REMINDER_RECIPIENTS = 5

export const RECIPIENT_LIMIT_MESSAGE = `A reminder can notify at most ${MAX_REMINDER_RECIPIENTS} people`

export const NOTIFY_REQUIRED_MESSAGE = 'Pick at least one person to notify'

export const CURRENT_ASSIGNEE_LABEL = 'Current assignee'

const STATUS_LABELS = {
  scheduled: 'Scheduled',
  sending: 'Sending',
  sent: 'Sent',
  partial: 'Partly sent',
  failed: 'Not delivered',
  cancelled: 'Cancelled',
  expired: 'Expired',
}

const STATUS_TONES = {
  scheduled: 'info',
  sending: 'info',
  sent: 'success',
  partial: 'warning',
  failed: 'error',
  cancelled: 'neutral',
  expired: 'neutral',
}

export const reminderStatusLabel = (status) => STATUS_LABELS[status] || ''

export const reminderStatusTone = (status) => STATUS_TONES[status] || 'neutral'

export const formatReminderTime = (at) => dayjs(at).tz(userTimeZone).format('MM/DD/YYYY h:mm A')

export const isTaskOverdue = (task) => {
  if (!task?.due || task?.status?.value === 'complete') return false
  return formatBusinessDate(task.due, 'YYYY-MM-DD') < dayjs().tz(businessTimeZone).format('YYYY-MM-DD')
}

export const sameIds = (left = [], right = []) => {
  const a = [...new Set(left.map(String))]
  const b = [...new Set(right.map(String))]
  return a.length === b.length && a.every((id) => b.includes(id))
}

const sameId = (a, b) => Boolean(a) && Boolean(b) && String(a) === String(b)

export const canEditTaskRow = (row, viewerId) => (
  sameId(row?.createdBy, viewerId) || sameId(row?.assignedTo, viewerId) || sameId(row?.assignedToData?._id, viewerId)
)

export const canDeleteTaskRow = (row, viewerId) => sameId(row?.createdBy, viewerId)
